import { useEffect, useState, useContext } from "react";
import toast from "react-hot-toast";
import PaymentTable from "./components/PaymentsList";
import { getAllClients } from "api/clients";
import { ClientContext } from "ClientProvider";
import { getSingleRole } from "api/graphQL_role";
import { getAllGatewaysSecond } from "api/graphQL_gateways";
import {  getCardType , getPaymentsFilter  } from "api/graphQL_payments";
import { getId } from "utils/auth";
export type PaymentRowObj = {
  id: any;
  payment_id: string;
  et_id: string;
  amount: string;
  currency: string;
  gateway_id: string;
  gateway_name: string;
  status: string;
  meta_info: any;
  payment_type: string;
  client: string;
  refund_info: string;
  created_at: string;
  image: string;
  all_data: any[];
  expanded: boolean;
  payment_history: any;
  gateway_response: any;
  card_type : any;
  customer_name : any;
};
const Payments = () => {
  const [payments, setPayments] = useState<PaymentRowObj[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>();
  const [isPaymentLoading, setIsPaymentLoading] = useState<boolean>();
  const [page, setPage] = useState<number>(0);
  const [totalpage, setTotalPage] = useState<number>(0);
  const [totalItems, setTotalItems] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(50);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [clients, setClients] = useState();
  const [value, setValue] = useState(false);
  const [curretClient, setCurrentClient] = useState<string>("all");
  const [allGateways, setAllGateways] = useState();
  const [allCardType, setCardType] = useState();
  const [searchTexts, setSearchTexts] = useState<string>("");
  const [localFilters, setLocalFilters] = useState<any>({});
  const [clearClicked,setClearClick] = useState(0)
  const { paymentType, singleRoleData, setSingleRoleData, setFilter, filter } = useContext(ClientContext);
  useEffect(() => {
    setFilter({});
  }, []);
  const fetchClients = () => {
    setIsLoading(true);
    getAllClients(0)
      .then((data) => {
        setClients(data);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ??
            "Something went wrong while fetching clients"
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  const fetchAllGateways = () => {
    setIsLoading(true);
    getAllGatewaysSecond()
      .then((data) => {
        setAllGateways(data);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ??
            "Something went wrong while fetching AllGateways"
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  const fetchCardType = () => {
    setIsLoading(true);
    getCardType()
      .then((data) => {
        setCardType(data);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ??
            "Something went wrong while fetching CardType"
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  };
  const fetchRole = () => {
    getSingleRole(getId())
      .then((data) => {
        setSingleRoleData(data ?? []);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ??
            "Something went wrong while fetching role"
        );
      })
      .finally(() => {});
  };
  useEffect(() => {
    fetchClients();
    // fetchRole();
    fetchAllGateways();
    fetchCardType();
  }, []);
  const serchboxValueChange = async (searchTerm: string) => {
    const search_txt = searchTerm || "";
    if (search_txt !== searchTexts && searchTexts !== "") {
      await setSearchTexts(search_txt);
      setPage(1);
    } else {
      await setSearchTexts(search_txt);
    }
  };
  const filterData = () => {
    const paymentType = filter?.status;
    const client = filter?.client;
    const gateway = filter?.gateway;
    const payment_status = filter?.payment_status;
    const card_type = filter?.card_type;
    const start_date = filter?.dates?.[0];
    const end_date = filter?.dates?.[1];
    const timezone = filter?.timezone;
    setIsPaymentLoading(true);
    getPaymentsFilter(
      page,
      pageSize,
      paymentType,
      client,
      gateway,
      card_type,
      payment_status,
      timezone,
      start_date,
      searchTexts,
      end_date
    )
      .then((data) => {
        setPayments(
          Object.entries(data.payments ?? {}).map(([key, value]: any) => {
            return {
              ...value[0],
              payment_id: key,
              expanded: false,
              all_data: value,
            };
          })
        );
        setTotalPage(data.total_pages);
        setTotalItems(data.total_items);
        setCurrentPage(data.current_page);
      })
      .catch((err) => {
      })
      .finally(() => {
        setIsPaymentLoading(false);
      });
  };
  useEffect(() => {
    if (page == 0) {
    } else {
      filterData();
    }
  }, [page, curretClient, pageSize, value,clearClicked]);
  useEffect(() => {
    setPage(1);
    setPageSize(50);
    setValue(!value);
  }, [paymentType, filter?.status, searchTexts]);
  const onClearClick = () => {
    setClearClick((prev) => {
      const newCount = prev + 1;
      return newCount;
    });
  };
  return (
    <>
      <div className="mt-5 pt-5">
        <PaymentTable
          pageSize={pageSize}
          setPageSize={setPageSize}
          tableData={payments}
          fetchPayments={filterData}
          isLoading={isPaymentLoading}
          page={page}
          setPage={setPage}
          totalpage={totalpage}
          totalItems={totalItems}
          currentPage={currentPage}
          clients={clients}
          allGateways={allGateways}
          allCardType={allCardType}
          curretClient={curretClient}
          setCurrentClient={setCurrentClient}
          roleData={singleRoleData}
          filterData={filterData}
          filter={filter}
          setFilter={setFilter}
          setClearClick={onClearClick}
          onValueChange={serchboxValueChange}
          setLocalFilters={setLocalFilters}
          localFilters={localFilters}
        />
      </div>
    </>
  );
};

export default Payments;
